// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-config__title[data-v-4d90b7b6]{user-select:none;margin-top:22px}`, "",{"version":3,"sources":["webpack://./src/components/CircleDetails/CircleConfigs.vue"],"names":[],"mappings":"AAEC,uCACC,gBAAA,CACA,eAAA","sourcesContent":["\n.circle-config {\n\t&__title {\n\t\tuser-select: none;\n\t\tmargin-top: 22px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
